import React, { useEffect, useState } from "react";
import {
  Container,
  Button,
  Card,
  CardBody,
  Spinner,
} from "reactstrap";
import {
  GetUserData,
  perPageData,
  showToastMessage,
} from "../../../../common/service/CommonService";
import tableStyles from "../../../../assets/scss/common/table.module.scss";
import Reason, {
  ReasonSubmitPayload,
} from "../../../../common/utilities/Reason/Reason";
import { useLocation, useNavigate } from "react-router-dom";
import { Volunteer, VolunteerFilterValues } from "../helper/volunteer.types";
import { useVolunteerService } from "../api/useVolunteerQuery";
import CommonTableIndexWise from "../../../../Components/Common/CommonTableIndexWise";
import { STUDY_PATHS, VOLUNTEER_PATHS } from "../../../../Routes/paths";
import { loadCodelistsDetailId } from "../../../../api/modules/common.option";
import VolunteerFilterModal from "../components/VolunteerFilterModal";
import { queryClient } from "../../../../api/queryClient";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import { VolunteerApiResponse } from "../helper/volunteer.types";
import AssignToStudyModal from "../components/AssignToStudyModal";
import CommonTabHeader from "../../../../Components/Common/CommonTabHeader";
import studyTabsStyles from "../../AssigningStudyModule/StudyScreeningTabs/css/studytabs.module.scss";
import sf from "../../../../assets/scss/common/searchFilter.module.scss"; // adjust path as needed
import {
  PERMISSION_ACTIONS,
  PERMISSION_MODULES,
} from "../../../../common/constants/PermissionConstants";
import CommonButton from "../../../../Components/Common/CommonButton";
import CommonSearch from "../../../../Components/Common/CommonSearch";
import FilePreviewModal from "../../../Study/Attachments/components/FilePreviewModal";
import {
  availableVolunteerColumn,
  assignedVolunteerColumn,
} from "../helper/volunteer.constant";
import { useAuditService } from "modules/Audit/api/useAuditQuery";
import AddVolunteer from "../components/AddVolunteer";
import { usePermission } from "context/PermissionContext";
import { useGlobalStudy } from "context/StudyContext";

/* ================= COMPONENT ================= */

const VolunteerList: React.FC = () => {

   const { hasPermission } = usePermission();
    const canAssign = hasPermission(
      PERMISSION_MODULES.VOLUNTEER,
      PERMISSION_ACTIONS.ASSIGN_STUDY,
    );
    
  const userData = GetUserData();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchText, setSearchText] = useState<string | null>(null);
  const [volunteerType, setVolunteerType] = useState<string>("available");
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showDeleteReason, setShowDeleteReason] = useState<boolean>(false);
  const [deleteReasonOpen, setDeleteReasonOpen] = useState(false);
  const [volunteerToDelete, setVolunteerToDelete] = useState<Volunteer | null>(
    null,
  );
  // const [assignedVolunteers, setAssignedVolunteers] = useState<number[]>(() => {
  //   const stored = JSON.parse(
  //     localStorage.getItem("assignVolunteerData") || "[]",
  //   );
  //   return stored.map((item: any) => item.volunteerid);
  // });
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [mainTab, setMainTab] = useState<"volunteer" | "study">("volunteer");
  const [selectedVolunteerId, setSelectedVolunteerId] = useState<number | null>(
    null,
  );
  const [volunteerToAssignName, setVolunteerToAssignName] = useState<
    string | null
  >(null);

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [mode, setMode] = useState<string>("add");
  const [filters, setFilters] = useState<VolunteerFilterValues>({});

  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [volunteerSubTab, setVolunteerSubTab] = useState<"Available" | "Assigned">("Available");

  //Audit
  const { SelectAllMutation: AuditMutation } = useAuditService();
  const [isPreviewOpen, setIsPreviewOpen] = useState<boolean>(false);
  const [previewFile, setPreviewFile] = useState<File | null>(null);
  const toggleAssignModal = () => setIsAssignModalOpen((p) => !p);

  const toggleFilter = () => setIsFilterOpen((p) => !p);
  const ToggleDeleteResason = () => setShowDeleteReason((p) => !p);

  const clearFilters = () => {
    setFilters({});
    setIsFilterApplied(false);
    refreshTableData();
  };

  const safeId = Number(selectedVolunteerId) ?? null;
  const { selectedStudy:globalstudy } = useGlobalStudy();

  const { SelectAllQuery, DeleteMutation, SelectQuery } = useVolunteerService({
    enableSelectAll: true,
    otherid: null,
    searchText: searchText,
    pageNumber: currentPageNumber,
    pageSize: perPageData,
    gender: filters?.gender,
    smoker: filters?.isSmoker,
    min_age: filters?.minAge,
    max_age: filters?.maxAge,
    minbmi: filters?.minbmi,
    maxbmi: filters?.maxbmi,
    alcoholresult: filters?.alcoholresult,
    bloodgroup: filters?.bloodgroup,
    educationlevel: filters?.educationlevel,
    foodhabit: filters?.foodhabit,
    city: filters?.city,
    screeningstatus: filters?.screeningPassed ,
    volunteertype: volunteerType,
    screeningfromdate: filters?.screeningFromDate,
    screeningtodate: filters?.screeningToDate,
    id: safeId,
    studyid:  Number(globalstudy?.studyid),
  });

  const {
    data: editVolunteerData,
    isLoading: editVolunteerLoading,
    isFetching: editVolunteerFetching,
    isError: editVolunteerError,
  } = SelectQuery as {
    data?: { data?: VolunteerApiResponse[] };
    isLoading: boolean;
    isFetching: boolean;
    isError: boolean;
  };
  const handleAssignSuccess = () => {
    // setAssignedVolunteers((prev) => [...prev, data.volunteerid]);
    setVolunteerSubTab("Assigned"); 
    setVolunteerType("assigned");
  };
  const gettedVolunteer = editVolunteerData?.data?.[0] ?? null;

  //-------------------------------------------------------------------------------------------
  //--> Page Start
  //-------------------------------------------------------------------------------------------

  const {
    data: queryResponse,
    isLoading,
    isError,
    isFetching,
  } = SelectAllQuery as {
    data?: { data?: (Volunteer & { total_count: number })[] };
    isLoading: boolean;
    isError: boolean;
    isFetching: boolean;
  };

  const data: (Volunteer & { total_count: number })[] =
    queryResponse?.data ?? [];
  /* -------------------------
        Toggles
  ------------------------- */
  const toggle = () => {
    setIsOpen((p) => !p);
  };
  const toggleDeleteModal = () => setDeleteModal((p) => !p);

  const refreshTableData = () => {
    if (currentPageNumber === 1) {
      queryClient.invalidateQueries({
        // queryKey: ["volunteer-selectAll",],
        queryKey: [
          "volunteer-selectAll",
          currentPageNumber,
          perPageData,
          searchText,
          filters,
        ],
      });
    } else {
      setCurrentPageNumber(1);
    }
  };

  /* -------------------------
      Active tab code 
  ------------------------- */

  useEffect(() => {
    if (location.pathname.includes("/screeninglist")) {
      setMainTab("study");
    } else {
      setMainTab("volunteer");
    }
  }, [location.pathname]);

  /* -------------------------
        Delete
  ------------------------- */

  const handleDeleteClick = (item: Volunteer) => {
    setVolunteerToDelete(item);
    setDeleteModal(true); // ✅ open delete modal first
  };

  const handleDeleteWithReason = (payload: ReasonSubmitPayload) => {
    if (!volunteerToDelete) return;

    DeleteMutation.mutate(
      { volunteerid: volunteerToDelete.id, updatereason: payload.reason },
      {
        onSuccess: (response) => {
          showToastMessage("success", response.message);
          queryClient.invalidateQueries({ queryKey: ["volunteer-selectAll"] });
          setSearchText(null);
          setCurrentPageNumber(1);
          setDeleteReasonOpen(false);
          setVolunteerToDelete(null);
          refreshTableData(); // Refresh data after successful delete
          toggleDeleteModal(); // Close delete modal if it's still open
        },
        onError: (error: any) => {
          console.error("Delete Error:", error);
          showToastMessage("error", error?.message ?? error);
        },
      },
    );
  };

  /* -------------------------
        Edit
  ------------------------- */

  const handleEditClick = (row: Volunteer) => {
    setSelectedVolunteerId(row.id);
    setIsOpen(true);
    setMode("edit");
  };

  /* -------------------------
        View
  ------------------------- */

  const handleViewClick = (row: Volunteer) => {
    localStorage.setItem("volunteerName", row.fullname);
    setMode("view");
    navigate(`${VOLUNTEER_PATHS.DETAILS}/${row.id}/`, {
      state: { mode: "view", type:`${volunteerType}` },
    });
    localStorage.setItem("volunteerType",volunteerType);
  };

  const onSearch = (text: string | null) => {
    setSearchText(text);
    if (text && text.trim().length > 0) {
      setFilters({});
      setIsFilterApplied(false);
    }
    setCurrentPageNumber(1);
  };

  const onAuditClick = () => {
    const payload = {
      modulename: "Volunteer",
    };

    AuditMutation.mutate(payload, {
      onSuccess: (data: any) => {
        if (data instanceof Blob) {
          const pdfFile = new File([data], "Volunteer_Audit_Log.pdf", {
            type: "application/pdf",
          });
          setPreviewFile(pdfFile);
          setIsPreviewOpen(true);
        }
      },
      onError: (error: any) => {
        showToastMessage("error", "Error fetching audit logs");
        console.error("Error fetching audit logs:", error);
      },
    });
  };

  useEffect(() => {
    const load = async () => {
      const result = await loadCodelistsDetailId([
        "Gender_OPTIONS",
        "BloodGroup_OPTIONS",
        "MedicalCode_OPTIONS",
        "IDPROOF_OPTIONS",
      ]);

      const allLoaded = Object.values(result).every((flag) => flag);
      if (!allLoaded) {
        showToastMessage("error", "Some dropdowns failed to load");
      }
    };
    load();
  }, []);



  const applyFilters = (values: VolunteerFilterValues) => {
    const isAllEmpty = Object.values(values).every(
      (value) => value === null || value === "" || value === undefined,
    );

    if (isAllEmpty) {
      setFilters({});
      setIsFilterApplied(false);
    } else {
      setFilters(values);
      setIsFilterApplied(true);
      setSearchText(null);
    }
    setCurrentPageNumber(1);
  };
  /* ================= RENDER ================= */
  const onADD = () => {
    setMode("add");
    setSelectedVolunteerId(null);
    toggle();
  };
  return (
  <div className="page-content">
    <Container fluid>
    
      <div className={"mt-3"}>
        <Card className={`${tableStyles.card} mb-0`}>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              {/* Premium Tab Segmented Switcher */}
              <div
                className="d-inline-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: "#f3f6f9",
                  borderRadius: "50px",
                  padding: "4px",
                  border: "1px solid #e9ebec",
                }}
              >
                <CommonButton
                  module={PERMISSION_MODULES.STUDY_SCREENING}
                  action={PERMISSION_ACTIONS.VIEW}

                  className={`btn btn-sm px-4 rounded-pill fw-semibold border-0 ${mainTab === "volunteer"
                      ? "text-primary shadow-sm"
                      : "text-muted"
                    }`}
                  style={{
                    backgroundColor:
                      mainTab === "volunteer" ? "#ffffff" : "transparent",
                    transition: "all 0.2s ease-in-out",
                  }}
                  onClick={() => navigate(VOLUNTEER_PATHS.LIST)}
                >
                  <i className="ri-team-line me-1" /> Volunteer
                </CommonButton>
                <CommonButton
                  module={PERMISSION_MODULES.STUDY_SCREENING}
                  action={PERMISSION_ACTIONS.VIEW}
                  className={`btn btn-sm px-4 rounded-pill fw-semibold border-0 ${mainTab === "study"
                      ? "text-primary shadow-sm"
                      : "text-muted"
                    }`}
                  style={{
                    backgroundColor:
                      mainTab === "study" ? "#ffffff" : "transparent",
                    transition: "all 0.2s ease-in-out",
                  }}
                  onClick={() => navigate(STUDY_PATHS.SCREENING_LIST)}
                >
                  <i className="ri-flask-line me-1" /> Study
                </CommonButton>
              </div>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
              {/* Sub-tabs for Available/Assigned */}
              {mainTab === "volunteer" && (
                <div 
                  className="d-flex align-items-center gap-4 px-1"
                  style={{ 
                    borderBottom: "1px solid #eff2f7",
                    marginBottom: "-1px" 
                  }}
                >
                  <div
                    className="position-relative cursor-pointer pb-2"
                    style={{ 
                      transition: "all 0.2s ease",
                      borderBottom: volunteerSubTab === "Available" ? "2px solid #1e6b91" : "2px solid transparent" 
                    }}
                    onClick={() => {
                        setVolunteerSubTab("Available"); 
                        setVolunteerType("available");
                        clearFilters();
                        setSearchText(null);
                      }}
                  >
                    <div className="d-flex align-items-center gap-2 px-1">
                      <i className={`ri-user-search-line ${volunteerSubTab === "Available" ? "text-primary" : "text-muted"}`} style={{ fontSize: "15px" }} />
                      <span
                        className={`fw-semibold ${
                          volunteerSubTab === "Available"
                            ? "text-primary"
                            : "text-muted"
                        }`}
                        style={{ 
                          fontSize: "12px",
                          letterSpacing: "0.2px"
                        }}
                      >
                        Available Volunteers
                      </span>
                    </div>
                  </div>

                  <div
                    className="position-relative cursor-pointer pb-2"
                    style={{ 
                      transition: "all 0.2s ease",
                      borderBottom: volunteerSubTab === "Assigned" ? "2px solid #1e6b91" : "2px solid transparent"
                    }}
                    onClick={() => {
                        setVolunteerSubTab("Assigned"); 
                        setVolunteerType("assigned");
                        clearFilters();
                        setSearchText(null);
                      }}
                  >
                    <div className="d-flex align-items-center gap-2 px-1">
                      <i className={`ri-checkbox-circle-line ${volunteerSubTab === "Assigned" ? "text-primary" : "text-muted"}`} style={{ fontSize: "15px" }} />
                      <span
                        className={`fw-semibold ${
                          volunteerSubTab === "Assigned"
                            ? "text-primary"
                            : "text-muted"
                        }`}
                        style={{ 
                          fontSize: "12px",
                          letterSpacing: "0.2px"
                        }}
                      >
                        Assigned Volunteers
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {/* Search and Filter */}
              <div className={sf.wrapper}>
                <CommonSearch
                  onSearch={onSearch}
                  searchText={searchText}
                  placeholder="Search..."
                />
                <button
                  className={`${sf.filterBtn} ${isFilterApplied ? sf.active : ""
                    }`}
                  onClick={toggleFilter}
                  title="Filter Volunteers"
                >
                  <i className="ri-filter-3-line" style={{ fontSize: 15 }} />
                  {isFilterApplied && <span className={sf.filterDot} />}
                </button>
              </div>

              {/* Action Buttons */}
              <div className="d-flex align-items-center gap-2">
                <CommonButton
                  module={PERMISSION_MODULES.VOLUNTEER}
                  action={PERMISSION_ACTIONS.AUDIT}
                  color="primary"
                  size="sm"
                  onClick={onAuditClick}
                  disabled={AuditMutation.isPending}
                  outline
                >
                  {AuditMutation.isPending ? (
                    <Spinner size="sm" className="me-2" />
                  ) : (
                    <i className="ri-history-line me-1"></i>
                  )}
                  Audit
                </CommonButton>
                <CommonButton
                  color="primary"
                  size="sm"
                  onClick={onADD}
                  outline
                  module={PERMISSION_MODULES.VOLUNTEER}
                  action={PERMISSION_ACTIONS.ADD}
                >
                  <i className="ri-add-line"></i> Add
                </CommonButton>
              </div>
            </div>

            {volunteerSubTab === "Available" ? (
              <CommonTableIndexWise
                columns={availableVolunteerColumn(
                  handleViewClick,
                  setSelectedVolunteerId,
                  setVolunteerToAssignName,
                  toggleAssignModal,
                  canAssign,
                )}
                data={isFetching ? [] : data}
                actions={{
                  onDelete: handleDeleteClick,
                  onEdit: handleEditClick,
                }}
                moduleName={PERMISSION_MODULES.VOLUNTEER}
                loading={isLoading || isFetching}
                pageSize={perPageData}
                currentPage={currentPageNumber}
                onPageChange={setCurrentPageNumber}
                totalRecords={queryResponse?.data?.[0]?.total_count || 0}
              />
            ) : (
              <CommonTableIndexWise
                columns={assignedVolunteerColumn(handleViewClick)}
                // columns={volunteerColumn(handleViewClick, setSelectedVolunteerId, setVolunteerToAssignName, toggleAssignModal,canAssign)}
                data={isFetching ? [] : data}
                actions={{
                  onDelete: handleDeleteClick,
                  onEdit: handleEditClick,
                }}
                moduleName={PERMISSION_MODULES.VOLUNTEER}
                loading={isLoading || isFetching}
                pageSize={perPageData}
                currentPage={currentPageNumber}
                onPageChange={setCurrentPageNumber}
                totalRecords={queryResponse?.data?.[0]?.total_count || 0}
              />
            )}
          </CardBody>
        </Card>
      </div>

      {/* ADD MODAL */}

      <AddVolunteer
        isOpen={isOpen}
        toggle={toggle}
        mode={mode}
        fetchedVolunteerData={gettedVolunteer}
        selectedVolunteerId={selectedVolunteerId}
        setVolunteerId={setSelectedVolunteerId}
      />

      {/* DELETE MODAL */}

      {volunteerToDelete && (
        <DeleteModal
          isopen={deleteModal}
          toggle={() => setDeleteModal(false)}
          recordId={volunteerToDelete?.id ?? 0}
          recordName={volunteerToDelete?.fullname}
          onDeleteClick={(payload: any) => handleDeleteWithReason(payload)}
          isLoading={DeleteMutation?.isPending}
          showDeleteReason={showDeleteReason}
          toggleDeleteReason={ToggleDeleteResason}
        />
      )}

      <VolunteerFilterModal
        isOpen={isFilterOpen}
        toggle={toggleFilter}
        onApply={applyFilters}
        onClear={clearFilters}
        existingFilters={filters}
      />

      <AssignToStudyModal
        isOpen={isAssignModalOpen}
        toggle={toggleAssignModal}
        volunteerId={selectedVolunteerId}
        volunteerName={volunteerToAssignName}
        onAssign={handleAssignSuccess}
      />
      {/* File Preview Modal */}
      {isPreviewOpen && (
        <FilePreviewModal
          file={previewFile}
          isOpen={isPreviewOpen}
          size={"xl"}
          onClose={() => {
            setIsPreviewOpen(false);
            setPreviewFile(null);
          }}
        />
      )}
    </Container>
    </div>
  );
};

export default VolunteerList;
